export enum CodigoPerfil {
  USUARIO_FINAL = 'usuarioFinal',
  MESA_PARTES = 'mesaPartes',
  ADMIN = 'admin',
  MPV = 'mpv',
  DESPACHO = 'mensajeria',
  FEDATARIO = 'fedatario',
  ADMIN_MPV = 'adminMpv',
  DIGITALIZACION = 'digitalizador',
  CONTROL_CALIDAD = 'controlCalidad',
  ARCHIVO_CENTRAL = 'archivo_central',
  SOPORTE_OTI = 'soporte_oti',
}
